/**
 * Consistent fallback shown wherever a Google Map can't render, so a
 * missing/rejected key never hangs on "Loading…" or crashes a page.
 */
export default function MapUnavailable({
  reason,
  height = 340,
}: {
  reason: 'keyMissing' | 'loadError'
  height?: number | string
}) {
  const message =
    reason === 'keyMissing'
      ? 'Map unavailable: Google Maps API key is not configured.'
      : 'Map unavailable: Google rejected the Maps key. Check the Cloud Console (HTTP-referrer restriction for this domain, billing, and that the Maps JavaScript API is enabled).'

  return (
    <div
      style={{
        height,
        display: 'grid',
        placeItems: 'center',
        textAlign: 'center',
        background: '#F1F5F9',
        border: '1px dashed #CBD5E1',
        borderRadius: 8,
        color: '#64748B',
        padding: 16,
        fontSize: 13,
      }}
    >
      {message}
    </div>
  )
}
